module.exports = {
  BASE_URL:
    process.env.REACT_APP_BASE_URL ||
    (process.env.NODE_ENV === "development"
      ? "http://localhost:3001"
      : "https://api.juanstream.com"),
  ADMIN: "GOGOPIX",
  SEC_ADMIN: "todd",
  ALCHEMY: "lharrison",
  DAN_AT_ALCHEMY: "dan@alchemy.stream",
};
